// extracted by mini-css-extract-plugin
export default {"FlyInText":"animation_FlyInText__EEHDE","L2R":"animation_L2R__lVb8z"};